<template>
    <div>
        <div class="text-5xl text-graytitle mb-6">Новый пароль</div>
        <b-input class="mb-3" v-model="code" max-length="10" @input="validate">Код</b-input>
        <b-input class="mb-1" v-model="newPassword" type="password" @input="onInput" max-length="30">Новый пароль</b-input>
        <div class="mb-5 text-sm text-graylight">
            <div :class="{ 'text-green': validation.length }">Не менее 8 символов</div>
            <div :class="{ 'text-green': validation.caps }">ЗаГлаВные и сТроЧные буквы</div>
            <div :class="{ 'text-green': validation.symbols }">Не менее 1цифры и $имвола</div>
        </div>
        <b-input class="mb-1" v-model="confirmPassword" type="password" max-length="30" @input="validate">Новый пароль еще
            раз</b-input>

        <div class="mb-4">
            <div v-if="confirmPassword" class="text-sm">
                <div class="text-green" v-if="isConfirmed">Пароль совпадает</div>
                <div class="text-red" v-else>Пароль не совпадает</div>
            </div>
        </div>
        <b-button :disabled="isDisabled" class="mb-4" :class="{'opacity-50': isDisabled}" @click="onSave">Сохранить</b-button>
    </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/authStore'
import { ref, computed } from 'vue'

const store = useAuthStore()

const code = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const validation = ref({
    length: false,
    symbols: false,
    caps: false
})
const isDisabled = ref(true)

const isCodeValid = computed(() => code.value.length === 6)
const isConfirmed = computed(() => newPassword.value === confirmPassword.value && isValid)
const isValid = computed(() => validation.value.length && validation.value.caps && validation.value.symbols)


async function onSave() {
    await store.passwordConfirm({code: code.value, password: newPassword.value})
}

function onInput() {
    validation.value.length = (newPassword.value.length > 7) ? true : false
    validation.value.symbols = newPassword.value.match(/^(?=.*\d)(?=.*[\W\_]).+$/) ? true : false
    validation.value.caps = newPassword.value.match(/^(?=.*[a-z])(?=.*[A-Z]).+$/) ? true : false
    validate()
}

function validate() {
    console
    if(isCodeValid.value && isConfirmed.value && isValid.value) {

        isDisabled.value = false
    } else {
        isDisabled.value = true
    }
}
</script>
